import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCreateDriver } from "./createDriver.request";
import { CreateDriverResponseData } from "./createDriver.types";

const useCreateDriver = (
  options?: MutationOptions<CreateDriverResponseData, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateDriver,
    ...options
  });
};

export default useCreateDriver;
